import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import Modal from "react-modal"
import SelectInput from "../../../Palettes/Propertybar/input/selectInput";
import { addLayerModalDeleteLayer, addLayerModalDeleteMoveLayer, setLayerModalLayers } from "../../../../store/interaction";
import LayersIcon from "../../../pictures/modal_pictures/2D_editor_icon_layer_w_20x20.png"
import LayerModalHeader from "./LayerModalHeader";
import LayerModalExitOptions from "./LayerModalExitOptions";
import { RootState } from "../../../../store/store";
import "./LayerDeleteWarnModal.css"

interface LayerDeleteWarnModalProps {
  item: Layer,
  setDeleteModalVisibility: (arg0: boolean) => void,
  removeLayerFromTempState: (layer: Layer) => void,
  showDeleteModal: boolean
}

function LayerDeleteWarnModal({
  item,
  setDeleteModalVisibility,
  removeLayerFromTempState: removeLayer,
  showDeleteModal }: Readonly<LayerDeleteWarnModalProps>) {
  const currentLayer = useAppSelector((state: RootState) => state.tool.currentLayer)
  const layerList = useAppSelector((state: RootState) => state.interaction.layerEditorModal.layerList)
  const dispatch = useAppDispatch();
  const [option, setOption] = useState<string>("moveLayers")
  const [moveToLayer, setMoveToLayer] = useState<number>(currentLayer)

  function closeModalWithOk() {

    if (option === "moveLayers") {
      dispatch(addLayerModalDeleteMoveLayer({ from: item.id, to: moveToLayer }))
      //dispatch(setLayerModalLayers({ deleteId: item.id }))
    } else if (option === "deleteLayers") {
      dispatch(addLayerModalDeleteLayer(item.id))
      //dispatch(deleteLayerForce({ deleteId: item.id }))
    }
    const listAfterDelete = (layerList.filter((i: Layer) => i.name !== item.name))
    dispatch(setLayerModalLayers(listAfterDelete))
    setDeleteModalVisibility(false)
    setOption("moveLayers")
  }
  function closeModalWithCancel() {
    setDeleteModalVisibility(false)
    setOption("moveLayers")
  }
  function radioChange(e: React.ChangeEvent<HTMLInputElement>) {
    setOption(e.target.value);
  }
  function findCurrentLayer() {
    if (currentLayer === item.id) {
      const layerToUseAfterCurrentLayer = layerList.find((i : Layer) => i.id !== item.id)
      return {
        label: layerToUseAfterCurrentLayer?.name ?? "",
        value: layerToUseAfterCurrentLayer?.id ?? currentLayer
      }
    } else {
      return {
        label: layerList.find((layer: Layer) => currentLayer === layer.id)?.name ?? "",
        value: currentLayer
      }
    }
  }
  return (
    <Modal
      overlayClassName={"layerModal__Overlay"}
      className="layerModal"
      isOpen={showDeleteModal}
      onAfterOpen={() => { }}
      onRequestClose={closeModalWithCancel}
      shouldCloseOnOverlayClick={true}
      contentLabel="Layers"
    >
      <LayerModalHeader icon={LayersIcon} title={"Delete Layer"} closeAction={closeModalWithCancel} />
      {/* <h2>Delete Layer</h2> */}
      <div className="textContent">
        <div>What to do with the contents of the deleted layer:</div>
        <ul className="radioOptionList">
          <li >
            <input
              type="radio"
              name="deleteOptionRadio"
              value="deleteLayers"
              onChange={radioChange} />
            <div>Delete</div>
          </li>
          <li>
            <input
              type="radio"
              name="deleteOptionRadio"
              value="moveLayers"
              onChange={radioChange}
              defaultChecked={true} />
            <div>Move</div>
          </li>
        </ul>

        <div className="container">
          <SelectInput

            choiseList={
              layerList
                .map((i: Layer) => {
                  return {
                    label: i.name, value: i.id
                  }
                })
                .filter((i: any) => i.value !== item.id)
            }
            properyDisplayName={"Move to:"}
            setValue={
              function (input): void {
                setMoveToLayer(input.value)
              }}
            currentValue={findCurrentLayer()}
            disabled={option !== "moveLayers"}
          />
        </div>
      </div>
      <LayerModalExitOptions
        okAction={closeModalWithOk}
        cancelAction={closeModalWithCancel}
      />
    </Modal>)
}
export default LayerDeleteWarnModal;